import React, { FC, useState } from "react";
import { UserInfo } from "@/store/globle/types";
import { Dropdown, MenuProps, Space } from "antd";
import { useLoginProvide } from "@/hooks/login";

const items: MenuProps["items"] = [
  {
    key: "1",
    label: "退出",
  },
];
const UserInfoArea: FC<{ userInfo: UserInfo }> = ({ userInfo }) => {
  const { toLoginOut } = useLoginProvide();
  const loginOut = () => {
    toLoginOut();
  };
  return (
    <Dropdown
      arrow={true}
      menu={{
        items,
        onClick: loginOut,
      }}
    >
      <a onClick={(e) => e.preventDefault()}>
        <Space>
          <div className="user-info">
            <div className="circle-surname">{userInfo.name.split("")[0]}</div>
            <div className="user-name">{userInfo.name}</div>
          </div>
        </Space>
      </a>
    </Dropdown>
  );
};
export default UserInfoArea;
